import SecaoBanner from './SecaoBanner';

export { SecaoBanner };

export default SecaoBanner;
